const KIT = [
  { icon: "ri-tools-line", label: "Crimping tool kit" },
  { icon: "ri-scissors-cut-line", label: "Cable strippers & cutters" },
  { icon: "ri-flashlight-line", label: "Cable tester + toner" },
  { icon: "ri-settings-3-line", label: "Precision driver set" },
  { icon: "ri-hammer-line", label: "Punch-down tool" },
  { icon: "ri-ruler-line", label: "Fish tape & pull string" },
  { icon: "ri-shield-user-line", label: "PPE & safety gear" },
  { icon: "ri-tools-fill", label: "Rolling tool bag" },
];

export default function Included() {
  return (
    <section id="included" className="relative bg-foreground-950 text-background-50 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-grid-lines opacity-20 pointer-events-none"></div>
      <div
        className="absolute -right-40 top-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, oklch(var(--primary-500) / 0.25), transparent 65%)" }}
      ></div>

      <div className="relative w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/20 border border-primary-500/40 text-primary-300 text-xs font-mono uppercase tracking-[0.2em] mb-4">
              <i className="ri-gift-2-line"></i> What's Included
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold leading-[1.05]">
              You show up. <br />
              <span className="text-primary-500">We hand you everything else.</span>
            </h2>
            <p className="mt-5 text-base md:text-lg text-background-200 max-w-xl leading-relaxed">
              Tuition covers a professional tool kit, a rugged laptop, all training materials,
              certification prep, and hands-on lab time. When you graduate, you keep the tools.
              You keep the laptop. You keep the skills.
            </p>

            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50/5 border border-background-50/10">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-macbook-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg">Rugged Laptop — Yours to Keep</h3>
                  <p className="text-sm text-background-300 mt-1">
                    Business-class laptop preloaded with diagnostic software, network tools, and everything you need on day one.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50/5 border border-background-50/10">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-tools-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg">$1,200+ Professional Tool Kit</h3>
                  <p className="text-sm text-background-300 mt-1">
                    The same tools our instructors use in the field — crimpers, testers, PPE, and a rolling bag.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50/5 border border-background-50/10">
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 shrink-0">
                  <i className="ri-user-star-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg">1-on-1 Career Coaching</h3>
                  <p className="text-sm text-background-300 mt-1">
                    Resume, interview prep, and warm introductions to our network of hiring partners.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-background-50/10 bg-background-50/5">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20photograph%20of%20a%20professional%20technician%20tool%20kit%20on%20dark%20workbench%20background%2C%20orange%20handled%20crimping%20tools%2C%20cable%20tester%20with%20blue%20screen%2C%20precision%20screwdriver%20set%2C%20wire%20strippers%2C%20punch%20down%20tool%2C%20cable%20labels%2C%20safety%20glasses%2C%20rugged%20laptop%20partially%20visible%2C%20warm%20accent%20lighting%20from%20above%2C%20dramatic%20cinematic%20knolling%20composition%2C%20highly%20detailed%20editorial%20product%20photography&width=1000&height=1200&seq=techy-included-kit-01&orientation=portrait"
                alt="Included tool kit"
                className="w-full h-[340px] sm:h-[440px] md:h-[560px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
                <div>
                  <div className="text-xs font-mono uppercase tracking-[0.2em] text-primary-300">
                    Included Kit
                  </div>
                  <div className="text-background-50 font-heading font-bold text-xl">Retail value $1,200+</div>
                </div>
                <div className="px-3 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold">
                  Yours to keep
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-2">
              {KIT.map((k) => (
                <div
                  key={k.label}
                  className="flex items-center gap-2 px-3 py-2.5 rounded-md bg-background-50/5 border border-background-50/10"
                >
                  <i className={`${k.icon} text-primary-400`} aria-hidden="true"></i>
                  <span className="text-xs text-background-200 font-medium">{k.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}